
    import './styles.scoped.css';
    export default {
  "calendar": "awsui_calendar_1ykar_11xrm_99",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1ykar_11xrm_1",
  "root": "awsui_root_1ykar_11xrm_130",
  "calendar-inner": "awsui_calendar-inner_1ykar_11xrm_171",
  "calendar-header": "awsui_calendar-header_1ykar_11xrm_175",
  "calendar-header-title": "awsui_calendar-header-title_1ykar_11xrm_180",
  "calendar-next-btn": "awsui_calendar-next-btn_1ykar_11xrm_188",
  "calendar-prev-btn": "awsui_calendar-prev-btn_1ykar_11xrm_191",
  "calendar-grid": "awsui_calendar-grid_1ykar_11xrm_194",
  "calendar-grid-dense": "awsui_calendar-grid-dense_1ykar_11xrm_198",
  "calendar-grid-cell": "awsui_calendar-grid-cell_1ykar_11xrm_206",
  "calendar-date-header": "awsui_calendar-date-header_1ykar_11xrm_211",
  "calendar-date": "awsui_calendar-date_1ykar_11xrm_211",
  "calendar-date-enabled": "awsui_calendar-date-enabled_1ykar_11xrm_231",
  "calendar-date-current-page": "awsui_calendar-date-current-page_1ykar_11xrm_241",
  "calendar-date-selected": "awsui_calendar-date-selected_1ykar_11xrm_252",
  "calendar-date-current": "awsui_calendar-date-current_1ykar_11xrm_241",
  "calendar-date-dense": "awsui_calendar-date-dense_1ykar_11xrm_273",
  "date-inner": "awsui_date-inner_1ykar_11xrm_281",
  "calendar-row": "awsui_calendar-row_1ykar_11xrm_356"
};
  